module.exports = __webpack_public_path__ + "static/media/bree.1dc31888.jpg";